// extracted by mini-css-extract-plugin
export default {"error":"Xb5aT_Xb5aT","forgot":"omuDo_omuDo","submitButton":"nGQjy_nGQjy"};